import React from 'react';
import DashboardHelp from './DashboardHelp';
import ProjectsHelp from './ProjectsHelp';
import SupportHelp from './SupportHelp';
import AssessmentsHelp from './AssessmentsHelp';
import ClientsHelp from './ClientsHelp';
import AWSEnvironmentsHelp from './AWSEnvironmentsHelp';
import FundingHelp from './FundingHelp';
import NotificationsHelp from './NotificationsHelp';
import WorkloadsHelp from './WorkloadsHelp';

interface HubHelpProps {
  activePage: string;
}

const HubHelp: React.FC<HubHelpProps> = ({ activePage }) => {
  switch (activePage) {
    case 'dashboard':
      return <DashboardHelp />;
    case 'projects':
      return <ProjectsHelp />;
    case 'support':
      return <SupportHelp />;
    case 'assessments':
      return <AssessmentsHelp />;
    case 'clients':
      return <ClientsHelp />;
    case 'aws-environments':
      return <AWSEnvironmentsHelp />;
    case 'funding':
      return <FundingHelp />;
    case 'notifications':
      return <NotificationsHelp />;
    case 'workloads':
      return <WorkloadsHelp />;
    default:
      return <DashboardHelp />;
  }
};

export default HubHelp;
